import ForestMapContainer from "./ForestMapContainer";

export default ForestMapContainer;